<template>
  <div
    style="width: 100%"
    class="ml-2"
  >
    <v-col
      v-for="f in filtro"
      :key="f.titulo"
      cols="12"
    >
      <filtro-base :value="f" />
    </v-col>
  </div>
</template>

<script>
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroFormacaoAcademica',

  components: { FiltroBase },

  data() {
    return {
      filtro: {
        formacao: {
          titulo: 'FORMAÇÃO ACADÊMICA',
          habilitado: true,
          filhos: [
            {
              id: 'escolaridades',
              tipo: 'select',
              titulo: 'Níveis de Escolaridade',
              habilitado: false,
              selecionado: [],
              lista: [
                { id: 'ENSINO_FUNDAMENTAL', nome: 'Ensino Fundamental' },
                { id: 'ENSINO_MEDIO', nome: 'Ensino Médio' },
                { id: 'ENSINO_PROFISSIONAL_TECNICO', nome: 'Ensino Profissional de Nível Técnico' },
                { id: 'GRADUACAO', nome: 'Graduação' },
                { id: 'ESPECIALIZACAO', nome: 'Especialização' },
                { id: 'ESPECIALIZACAO_RESIDENCIA_MEDICA', nome: 'Especialização - Residência médica' },
                { id: 'MESTRADO_ACADEMICO', nome: 'Mestrado Acadêmico' },
                { id: 'MESTRADO_PROFISSIONAL', nome: 'Mestrado Profissional' },
                { id: 'DOUTORADO_ACADEMICO', nome: 'Doutorado Acadêmico' },
                { id: 'DOUTORADO_PROFISSIONAL', nome: 'Doutorado Profissional' },
                { id: 'POS_DOUTORADO', nome: 'Pós-Doutorado' },
              ],
              itemText: 'nome',
              icone: 'menu_book',
              multiplo: true,
              colunas: 12,
              filhos: [],
            },
            {
              id: 'cursos',
              tipo: 'select',
              titulo: 'Cursos',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.cursos.filter((c) => c.id),
              itemText: 'nome',
              icone: 'school',
              multiplo: true,
              colunas: 12,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'areasPesquisa',
              tipo: 'select',
              titulo: 'Áreas de Pesquisa',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaAreasPesquisa.filter((c) => c.id),
              itemText: 'nome',
              icone: 'emoji_objects',
              multiplo: true,
              todas: true,
              colunas: 12,
              filhos: [],
            },
          ],
        },
      },
    };
  },

  watch: {
    filtro: {
      handler(value) {
        const filtroEscolaridades = FiltroPerfil.get('escolaridades', value.formacao.filhos);
        const filtroCursos = FiltroPerfil.get('cursos', value.formacao.filhos);
        const filtroCursosOutros = FiltroPerfil.get('outros', filtroCursos.filhos);
        const filtroAreasPesquisa = FiltroPerfil.get('areasPesquisa', value.formacao.filhos);

        const retorno = {
          escolaridades: FiltroPerfil.getRetorno(filtroEscolaridades),
          cursos: {
            ...FiltroPerfil.getRetorno(filtroCursos),
            outros: FiltroPerfil.getRetorno(filtroCursosOutros),
          },
          areasPesquisa: FiltroPerfil.getRetorno(filtroAreasPesquisa),
        };
        retorno.habilitado = FiltroPerfil.getHabilitado(retorno);
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
